import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Pricing from './pages/Pricing';
import MySubscription from './pages/MySubscription';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { LanguageProvider } from './i18n/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCanceled from './pages/SubscriptionCanceled';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  padding-top: 80px;
  flex: 1;
`;

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <LanguageProvider>
            <AppContainer>
              <Navbar />
              <MainContent>
                <Routes>
                  <Route path="/" element={
                    <>
                      <Hero />
                      <Features />
                      <FAQ />
                    </>
                  } />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/mySubscription" element={<MySubscription />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                  <Route path="/subscription-canceled" element={<SubscriptionCanceled />} />
                </Routes>
              </MainContent>
              <Footer />
            </AppContainer>
          </LanguageProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
};

export default App; 